import React, { useState } from 'react';
import { Icon, Button } from '@iq/react-components';

const InlineEditor = ({ value, onSave, uniqueItems = [], uniqueError = '' }) => {
  const [isEditMode, setEditMode] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  const [error, setError] = useState(null);

  const handleOnSave = () => {
    const isSame = localValue.trim().toLowerCase() === value.toLowerCase();
    if (!isSame && uniqueItems.includes(localValue.trim().toLowerCase())) {
      setError(uniqueError);
    } else {
      onSave(localValue.trim());
      setEditMode(false);
    }
  };

  const handleChange = (e) => {
    setLocalValue(e.target.value);
    setError(null);
  };

  return (
    <div
      data-testid="inline-editor"
      className="inline-editor-component"
    >
      {!isEditMode && <React.Fragment>{value}</React.Fragment>}
      {isEditMode && (
        <input
          data-testid="input-element"
          type="text"
          value={localValue}
          onChange={handleChange}
        />
      )}
      <span className="controls">
        <Button
          data-testid="edit-button"
          activity="secondary"
          slim
          onClick={() => setEditMode(!isEditMode)}
          icon={<Icon icon={isEditMode ? 'he-close' : 'he-edit'} />}
        />
        {isEditMode && (
          <>
            <Button
              data-testid="save-button"
              activity="primary"
              slim
              onClick={handleOnSave}
              icon={<Icon icon="he-check" />}
            />
            <div
              data-testid="error-message"
              className="error"
            >
              {error}
            </div>
          </>
        )}
      </span>
    </div>
  );
};

export default InlineEditor;
